import React from "react";
import { Button, Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerActiveTab } from "../../store/slices/homeSlice";
import LegislationTab from "./LegislationTab";
import PolicyDetail from "../PolicyDetail";
import {
  legislationData,
  policiesAndProceduresData,
} from "../PolicyDetail/data";

const BehaviourSupportPlanDrawer = () => {
  const { drawerActiveTab } = useSelector((state) => state.home);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setDrawerActiveTab(""));
  };

  return (
    <Drawer
      title="Behaviour Support Plan - Comprehensive"
      placement={"right"}
      onClose={onClose}
      open={drawerActiveTab !== ""}
      key={"right"}
      width={1080}
      className="supportPlanDrawer"
    >
      <div>
        <DrawerTabs />
        <div className="drawerBody">
          {drawerActiveTab === "Legislation" && (
            <PolicyDetail
              data={legislationData}
              sidebar={false}
              bgColor={"#fff"}
            />
          )}
          {drawerActiveTab === "Policies & Procedures" && (
            <PolicyDetail
              data={policiesAndProceduresData}
              sidebar={false}
              bgColor={"#fff"}
            />
          )}
          {drawerActiveTab === "Forms" && <LegislationTab />}
        </div>
      </div>
    </Drawer>
  );
};

const DrawerTabs = () => {
  const { drawerActiveTab } = useSelector((state) => state.home);
  const dispatch = useDispatch();

  return (
    <div className="drawerTabWrapper">
      <div className="drawerTab">
        {["Legislation", "Policies & Procedures", "Forms"].map((tab, index) => {
          return (
            <Button
              onClick={() => dispatch(setDrawerActiveTab(tab))}
              key={index}
              className={tab === drawerActiveTab ? "activeTab" : ""}
            >
              {tab}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default BehaviourSupportPlanDrawer;
